// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-6c53fddf] .el-col-md-24 {\n  margin-left: -20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
